import { render, staticRenderFns } from "./Home1.vue?vue&type=template&id=21c4867e"
import script from "./Home1.vue?vue&type=script&lang=js"
export * from "./Home1.vue?vue&type=script&lang=js"
import style0 from "./Home1.vue?vue&type=style&index=0&id=21c4867e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports